import { ConversationMessage, FolderMessage } from '../../../models/communication.types';
import { convertToFormatDate, convertToFormatTime, isDateToday } from '../../../utils/dateFunctionUtils';
import MessageCell from './MessageCell.component';

interface DateCellProps {
  message: FolderMessage | ConversationMessage;
  isRead: boolean;
  smallerFont?: boolean;
}

const DateCell: React.FC<DateCellProps> = ({ message, smallerFont, isRead }) => {
  return (
    <MessageCell isRead={isRead} smallerFont={smallerFont}>
      <div style={{ textAlign: 'left', paddingRight: '5px' }}>
        {isDateToday(message.sentDate) ? convertToFormatTime(message.sentDate) : convertToFormatDate(message.sentDate)}
      </div>
    </MessageCell>
  );
};

export default DateCell;
